import { get, post } from '@/utils/http.js'

export const getNotice = (data) => post('/monitor/firewar', data)

export const getWater = (data) => post('/monitor/waterwar', data)

export const getelectro = (data) => post('/monitor/elerwar', data)
export const getVideo = (data) => post('/monitor/videowar', data)
export const getwaterbeng = (data) => post('/monitor/bengwar', data)
export const getWind = (data) => post('/monitor/fengwar', data)
export const getpotency = (data) => post('/monitor/wifiwar', data)
export const getsmoke = (data) => post('/monitor/wifismokewar', data)

// 应急照明
export const getlight = (data) => get('/device/monitorDevice/emergencyLightingList', data)
// 风检测侧
export const windlist = (data) => get('device/monitorDevice/smokeControlFanList', data)
// 风机检测搜索列表
export const windSearchList = (data) => { return get('/device/fanDataStatistics/list', data) }
// 室外消火栓
export const outdoorlist = (data) => get('device/monitorDevice/outdoorHydrantList', data)
// 室外消火栓echarts
export const fireHydrantData = (data) => get('/device/monitorDevice/fireHydrantData', data)
// 消防电源
export const SupplyList = (data) => get('/device/monitorDevice/mainAndStandbyPowerSupplyList', data)
// 气体灭火
export const gasFireList = (data) => get('/device/monitorDevice/gasFireExtinguishList', data)
//气体灭火搜索列表
export const gasFireSearch = (data) => { return get('/device/monitorDevice/gasFireExtinguish', data) }
// 电气监控搜索
export const electriList = (data) => { return get('/device/monitorDevice/electricalMonitor', data) }
// 获取水泵数据
export const waterPumpList = (data) => get('/mqtt/mqttInfo/waterPumpList', data)
// 喷淋末端压力水压数据列表
export const waterSystemPressureNew = (data) => { return get('/monitor/waterSystemPressureNew', data) }
// 操作记录列表
export const OperationRecordsList = (data) => { return get('/mqtt/mqttOperationRecord/list', data) }

